import { CalculateDimensions } from "../horizontal_scrollbar.types";

export const calculateScrollbarDimensions = ({
  contentRef,
  scrollableContainer,
  scrollbarContainerRef,
  scrollbarRef,
  getContentWidth,
  getWindowWidth,
  minThumbWidth
}: Omit<CalculateDimensions, "scrollbarDraggingData">) => {
  if (
    !contentRef.current ||
    !scrollbarContainerRef.current ||
    !scrollbarRef.current ||
    !scrollableContainer
  ) {
    return { left: 0, width: 0 };
  }

  const contentWidth = getContentWidth();
  const scrollbarContainerWidth = scrollbarContainerRef.current.clientWidth ?? 0;
  const scrollbarContainerVisibleAreaWidth = getWindowWidth();
  const { scrollLeft } = scrollableContainer;

  const proportionalWidth = (scrollbarContainerVisibleAreaWidth / contentWidth) * scrollbarContainerWidth;
  const width = Math.max(proportionalWidth, minThumbWidth ?? 0);

  const maxScrollLeft = Math.max(0, scrollableContainer.scrollWidth - scrollableContainer.clientWidth);
  const maxThumbLeft = scrollbarContainerWidth - width;
  const left = maxScrollLeft > 0 ? (scrollLeft / maxScrollLeft) * maxThumbLeft : 0;

  const percentage = Math.round((scrollLeft / contentWidth) * 100);
  return { left, width, percentage };
};
